<template>
  <rmp-base-modal
    v-model="isOpen"
    extra-classes="BorderedHeaderModal EventsHelpModal"
  >
    <template #modal-header>
      <h2 class="u-text-center">
        Help
      </h2>
    </template>
    <template #modal-body>
      <ul class="EventsTableLegend">
        <li><strong>Type:</strong> <span class="Icon-s Icon-bolt" /> A dynamic form where each question is presented in a single page, allowing you to build an enhanced experience.</li>
        <li><strong>Type:</strong> <span class="Icon-s Icon-clipboard-list" /> A static form, your traditional type of form where all questions are displayed at once.</li>
        <li><strong>Event date:</strong> Accepts registrations until this date.</li>
        <li><strong>Visibility:</strong> Whether students can or not view the form despite the event date.</li>
      </ul>
    </template>
  </rmp-base-modal>
</template>
<script>

import RmpBaseModal from '@rmpenterprise/base-modal';
import ModalActionsMixin from './mixins/modal-actions-mixin';

export default {
  components: { RmpBaseModal },
  mixins: [ModalActionsMixin],
};
</script>
<style lang="scss" scoped>

.EventsTableLegend{
  list-style: disc;
}
li {
  padding: 0 0 15px 0;
}
</style>
